import { KYMW2500Model } from '../kymw2500.model';
import { RegistPageCopyModel } from '../vo/regist-page-copy.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページテンプレート削除コマンド。
 * 指定されたテンプレート情報を削除する。
 *
 * @export RegistPageCopyService
 * @class RegistPageCopyService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistPageCopyService extends PlessJsonResponderSub<any> {
  private model: KYMW2500Model = null;
  private vo: RegistPageCopyModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPageCopyService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Rec: {
          condition: {
            BeforeCoopCode: this.vo.BeforeCoopCode,
            BeforeOrderCode: this.vo.BeforeOrderCode,
            CoopCode: this.vo.CoopCode,
            OrderCode: this.vo.OrderCode,
            MediumType: this.vo.MediumType
          },
          combination: this.vo.SaitamaPageList.map((v, i) => {
            return {
              condition: {
                IbarakiPage: this.vo.IbarakiPageList[i],
                TochigiPage: this.vo.TochigiPageList[i],
                GunnmaPage: this.vo.GunnmaPageList[i],
                ChibaPage: this.vo.ChibaPageList[i],
                SaitamaPage: this.vo.SaitamaPageList[i],
                TokyoPage: this.vo.TokyoPageList[i],
                NaganoPage: this.vo.NaganoPageList[i],
                NiigataPage: this.vo.NiigataPageList[i],
                KurucoPage: this.vo.KurucoPageList[i]
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2500Model} model モデルクラス
   * @param {RegistPageCopyModel} vo ページネーション詳細設定VO
   * @memberof RegistPageCopyService
   */
  execute(model: KYMW2500Model, vo: RegistPageCopyModel) {
    this.model = model;
    this.vo = vo;
    this.send('registPageCopy', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistPageCopyService
   */
  success(data: any) {
    // ページネーション選択エリアのボタンを非活性化する
    this.model.kymw2500Component.disablePagenationListButton();
    // ページネーション詳細エリアを非活性化する
    this.model.kymw2500Component.disablePagenationDetail();
    // ページネーション詳細エリアをクリア
    this.model.kymw2500Component.clearPagenationDetail();
    // ページネーション選択一覧を最新の情報に更新する
    this.model.kymw2500Component.reloadPagenationList();
  }
}
